shadow$provide[100] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Api:{enumerable:true, get:function() {
  return Api;
}}});
class Api {
  static apply(object) {
    object.set = function(options) {
      const o = this.options || {};
      const changes = Object.entries(options).reduce(function(result, [key, value]) {
        if (o[key] !== value) {
          result[key] = value;
        }
        return result;
      }, {});
      this.options = Object.assign(o, changes);
      this.trigger({type:"change", options:options, changes:changes});
    };
    object.get = function() {
      return this.options;
    };
    object.api = function(object, context) {
      if (!object) {
        object = {};
      }
      context && Object.entries(object).forEach(function([key, callback]) {
        if (typeof callback === "function") {
          object[key] = (...args) => callback(...args, context);
        }
      });
      object.set = this.set.bind(this);
      object.get = this.get.bind(this);
      return object;
    };
  }
}

};